module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAATUlEQVQImWXJoQ2AQBQE0ceBw2MoAIuhDArA0gGNICgFhaCBa+gcCeYLEsZsZqdqumnH5s9Rp7a/MWL4hBNrwoMFOUIOf1IcBTOu2AIvSMgLtFTrInQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/down1.png
// module id = esZj
// module chunks = 601